<template>
    <section class="card-front-sec" v-if="card">
        <div class="container">
            <div class="card-front-sec__img_wrapper">
                <div class="card-front-sec__img-container">
                    <template v-for="(img, index) in card.images" :key="img.id">
                        <div v-if="index === 0 || index === 1" class="card-front-sec__img  card-front-sec__img_large  "
                             itemscope=""
                             itemtype="http://schema.org/ImageObject">
                            <meta itemprop="name" :content="card.name">
                            <meta itemprop="description"
                                  :content="card.description">
                            <picture class="card-front-sec__img-element " @click="toggler = !toggler;imgIndex = index">
                                <img :src="img.webp"
                                     :alt="card.name"
                                     class="card-front-sec__img-element glightbox" itemprop="contentUrl">
                            </picture>
                        </div>
                        <div v-if="index > 1 && index <5" class="card-front-sec__img  " itemscope=""
                             itemtype="http://schema.org/ImageObject">
                            <meta itemprop="name" :content="card.name">
                            <meta itemprop="description"
                                  :content="card.description">
                            <picture class="card-front-sec__img-element " @click="toggler = !toggler;imgIndex = index">
                                <img :src="img.webp"
                                     :alt="card.name"
                                     class="card-front-sec__img-element glightbox" itemprop="contentUrl">
                            </picture>
                        </div>
                    </template>
                </div>

                <div class="card-front-sec__link-row" itemscope itemtype="https://schema.org/BreadcrumbList">
                    <div itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                        <a itemprop="item" :href="'/catalog/'+this.$store.state.settings.gender"
                           class="card-front-sec__link">
                            <span itemprop="name">{{ trans(this.$store.state.settings.gender) }}</span>
                        </a>
                        <meta itemprop="position" content="1"/>
                    </div>
                    <img class="card-front-sec__link-img" :src="'/img/svg/ar-credit.svg'" alt="">
                    <div itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                        <a itemprop="item"
                           :href="'/catalog/'+this.$store.state.settings.gender+'/'+this.card.category_link"
                           class="card-front-sec__link">
                            <span itemprop="name"> {{ card.category_name }}</span>
                            <meta itemprop="position" content="2"/>
                        </a>
                    </div>
                </div>
            </div>

            <div class="card-front-sec__info" itemscope itemtype="http://schema.org/Product">
                <h1 itemprop="name" class="sec-title"> {{ card.name }} </h1>
                <div class="single-product-sec__price-row" v-if="card.sizes.length > 0">
                    <meta itemprop="description" :content="card.description">
                    <meta v-if="card.images[0]" itemprop="image" :content="card.images[0].jpeg">
                    <div itemprop="offers" itemscope itemtype="http://schema.org/Offer" class="single-product-sec__price-row">
                        <p itemprop="price" class="product__main-price product__text-def" v-if="!card.offer.price_old_str">
                            {{ card.offer.price_str }}
                            {{ card.signs }}
                        </p>

                        <template v-if="card.offer.price_old_str">
                            <p class="product__sale-price product__text-def">{{ card.offer.price_str }} {{card.signs}}</p>
                            <p itemprop="price" class="product__old-price"> {{ card.offer.price_old_str }} {{card.signs}}</p>
                        </template>

                        <meta itemprop="priceCurrency" :content="card.currency_code">
                        <link itemprop="availability" href="http://schema.org/InStock">
                    </div>
                </div>

                <div class="single-product-sec__price-row" v-if="card.sizes.length === 0 || !card.offerForPurchaseQuantity">
                    <p class="product__main-price product__text-def">{{ trans('Out of stock') }}</p>
                </div>

                <a class="card-front-sec__credit-row air-open-btn split-air"
                   v-if="dolyami && card.sizes.length > 0"
                   @click="$refs.dolyami.dolyamiAir = !$refs.dolyami.dolyamiAir">
                    <img src="https://batnorton.com/img/credit.png" alt="">
                    <span class="card-front-sec__credit-row-text">   – 4 платежа по <span
                        id="sum-split">{{ splitPayment(card) }}</span>
                                     </span>
                    <img src="https://batnorton.com/img/svg/ar-credit.svg" alt="">
                </a>

                <Dolyami v-if="dolyami" :card="card" ref="dolyami"/>

                <div v-if="card.offerForPurchaseQuantity" class="select-size">
                    <div class="select-size__header" v-if="card.sizes.length > 0" @click="selectList = !selectList">
                        <p class="select-size__header-title">
                            {{ trans('Size') }} : {{ card.sizes[offerSizeKey].code }}
                        </p>
                        <img class="select-size__header-img" :src="'/img/svg/select-ar.svg'" alt="select size">
                    </div>

                    <div class="select-size__body section-offers" v-show="selectList">
                        <ul class="list select-size__list">
                            <li class="list__element select-size__element"
                                v-for="(sizes,index) in card.sizes"
                                :key="sizes.id"
                                :class="getSizeClass(sizes)"
                                @click="sizeClick(index, sizes)">
                                <span class="select-size__element-value">
                                    {{ sizes.code }}
                                    <span v-if="!sizes.purchase" class="select-size__element-unavailable">
                                        <svg width="11" height="11" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 0C2.69169 0 0 2.69169 0 6C0 9.30831 2.69169 12 6 12C9.30831 12 12 9.30831 12 6C12 2.69169 9.30831 0 6 0ZM6 0.923077C8.80938 0.923077 11.0769 3.19062 11.0769 6C11.0769 8.80938 8.80938 11.0769 6 11.0769C3.19062 11.0769 0.923077 8.80938 0.923077 6C0.923077 3.19062 3.19062 0.923077 6 0.923077ZM5.53846 3.23077V5.53846H3.23077V6.46154H5.53846V8.76923H6.46154V6.46154H8.76923V5.53846H6.46154V3.23077H5.53846Z"/>
                                        </svg>&nbsp;&nbsp;{{trans('Add to waiting list')}}
                                    </span>
                                </span>
                                <span class="select-size__element-value">{{ sizes.price_str }} {{card.signs}}</span>
                                <span v-if="sizes.price_old_str" class="select-size__element-value"><s>{{ sizes.price_old_str }} {{card.signs}}</s></span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="single-product-sec__btn-row">
                    <div v-if="card.offerForPurchaseQuantity" class="single-product-sec__add-to-cart-btn-row">
                        <template v-if="addToCard">
                            <a href="/personal/orders/basket" class="btn btnV2 product-page__add-to-cart-btn"
                               style="width: 100%">{{ trans('Go to the shopping cart') }}
                            </a>
                            <button class="btn btnV2 product-page__add-btn" @click="addBasketCard(card)"> +1
                            </button>
                        </template>
                        <button v-if="!addToCard " @click="addToCard = !addToCard;addBasketCard(card)"
                                :disabled="addToCartDisabled"
                                id="google-addBasket" class="btn btnV2 product-page__add-to-cart-btn"
                                style="width: 100%">
                            {{ trans('Add to Cart') }}
                        </button>
                    </div>
                    <div class="v-popper v-popper--theme-tooltip">
                        <div class="add-like " :class="card.favourites ? 'active-like': ''"
                             @click="addFavourites(card)">
                            <svg class="svg-icon" width="22" height="18" viewBox="0 0 22 18" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11 17.25C11 17.25 1.625 12 1.625 5.62501C1.625 4.49803 2.01546 3.40585 2.72996 2.53431C3.44445 1.66277 4.43884 1.0657 5.54393 0.844677C6.64903 0.623658 7.79657 0.792346 8.79131 1.32204C9.78605 1.85174 10.5665 2.70972 11 3.75001V3.75001C11.4335 2.70972 12.2139 1.85174 13.2087 1.32204C14.2034 0.792346 15.351 0.623658 16.4561 0.844677C17.5612 1.0657 18.5555 1.66277 19.27 2.53431C19.9845 3.40585 20.375 4.49803 20.375 5.62501C20.375 12 11 17.25 11 17.25Z"
                                    stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <DeliveryCard :card/>
            </div>
        </div>
    </section>

    <template v-if="card">
        <FsLightbox type="image"
                    :toggler="toggler"
                    :sources="card.glightbox"
                    :index="imgIndex"
        />
    </template>

    <section class="card-dop-sec" v-if="card">
        <div class="container">
            <ul class="list card-dop-sec__nav-line">
                <li class="list__element card-dop-sec__nav-line-element "
                    :class="tab == 0 ?'card-dop-sec__nav-line_active':''" @click="tab = 0">
                    {{ trans('About the product') }}
                </li>
                <li class="list__element card-dop-sec__nav-line-element"
                    :class="tab == 1 ?'card-dop-sec__nav-line_active':''" @click="tab = 1">
                    {{ trans('Size Chart') }}
                </li>
            </ul>
            <div class="card-dop-sec__body">
                <div class="card-dop-sec__tab ">
                    <div class="card-dop-sec__tab-header showPanels" @click="tab = 0">
                        <p class="card-dop-sec__tab-header-title"> {{ trans('About the product') }} </p>
                        <svg class="svg-icon" width="10" height="7" viewBox="0 0 10 7" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.00098 1.2749L5.00048 5.2749L9.00048 1.2749" stroke="black"
                                  stroke-width="1.5"></path>
                        </svg>
                    </div>
                    <div class="card-dop-sec__hide-element about-card" v-show="tab == 0 ">
                        <div class="about-card__left">
                            <div class="about-card__col1">
                                <h2 class="sec-title"> {{ card.name }}</h2>
                                <div class="about-card__more-text-container">
                                    <div class="about-card__more-text-box" :style="textShow ? 'max-height: 100%;' : ''">
                                        <p class="text-element text-element-js">
                                            {{ card.description }}
                                        </p>
                                    </div>
                                </div>

                                <div class="about-card__more-text-btn about-card__more-text-btn-js"
                                     v-if="card.description.length > 170 && readShow"
                                     @click="textShow = true;readShow = !readShow">
                                    {{ trans('Read completely') }}
                                    <svg class="svg-icon" width="8" height="5" viewBox="0 0 8 5" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 0.5L3.99963 3.5L6.99963 0.5" stroke="#9B9FA1"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="about-card__col2" v-if="card.structure?.name">
                                <div class="about-card__row-cont">
                                    <p class="text-element">
                                        <b> {{ trans('Composition') }} </b>
                                    </p>
                                    <p class="text-element"> {{ card.structure?.name }} </p>
                                </div>
                            </div>
                        </div>

                        <div class="about-card__img">
                            <picture>
                                <img :src="card.description_image" class="img-element" :alt=" card.name">
                            </picture>
                        </div>
                    </div>
                </div>

                <div class="card-dop-sec__tab">
                    <div class="card-dop-sec__tab-header showPanels" @click="tab = 1">
                        <p class="card-dop-sec__tab-header-title"> {{ trans('Size Chart') }} </p>
                        <svg class="svg-icon" width="10" height="7" viewBox="0 0 10 7" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.00098 1.2749L5.00048 5.2749L9.00048 1.2749" stroke="black"
                                  stroke-width="1.5"></path>
                        </svg>
                    </div>
                    <div class="card-dop-sec__hide-element table-size" v-show="tab == 1 ">
                        <div class="size-schema table-size">
                            <div class="table-size__info">
                                <div class="size-schema__title sec-title">{{ card.sizes_schema?.name }}</div>
                                <div class="size-schema__table" v-html="card.sizes_schema?.table"></div>
                                <p class="table-size__text">{{ trans('The dimensions are given in centimeters') }}</p>
                            </div>

                            <div class="size-schema__image table-size__img about-card__img">
                                <picture>
                                    <!--                                    <source :srcset="card.sizes_schema.sizes_schema_images?.webp" type="image/webp">-->
                                    <img :src="card.sizes_schema.sizes_schema_images?.jpeg" class="img-element"
                                         :alt=" card.category_name" v-if="card.sizes_schema.sizes_schema_images?.jpeg">
                                    <img :src="'/img/no-image.jpg'" class="img-element"
                                         :alt=" card.category_name" v-else>

                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Similar :cards="this.card.verticalImageSimilars.map(item =>  {
        return item.card_id
    })" v-if="card"/>

    <viewed/>
    <ProductSizeSubscription v-model:current-size-id="currentSizeUnavailableId" :sizes="cards.sizes" />
</template>

<script>
import FsLightbox from "fslightbox-vue/v3";
import Dolyami from "../../components/Airs/dolyami.vue";
import Viewed from '../../components/viewed.vue'
import DeliveryCard from '../../components/deliveries-card.vue'
import Similar from '../../components/similar.vue'
import store from "../../store.js";
import ProductSizeSubscription from "../../components/Airs/ProductSizeSubscription.vue";
import { viewItem } from '../../services/ga4Ecommerce.js';

export default {
    props: {
        cards: Object,
    },
    components: {FsLightbox, Dolyami, Viewed, DeliveryCard,Similar,ProductSizeSubscription},
    name: "index",
    data() {
        return {
            card: null,
            toggler: false,
            imgIndex: 1,
            dolyami: this.$store.state.settings.settings?.dolyami,
            dolyamiAir: false,
            selectList: false,
            offerSizeKey: 0,
            currentSizeUnavailableId: 0,
            addToCard: false,
            inputSearchCity: false,
            searchCities: '',
            deliveries: [],
            citiesList: [],
            tab: 0,
            textShow: false,
            readShow: true,
            width: window.innerWidth,
            height: window.innerHeight,
        }
    },
    created() {

    },
    mounted() {
        this.cards.sizes.sort((a, b) => (a.sort > b.sort) ? 1 : -1)
        this.card = this.cards

        const sizes = this.card.sizes;
        this.offerSizeKey = sizes.findIndex(size => size.id === this.card.offer.size.id)
        this.checkLike()
        this.createViewed(this.card)

        if (this.$store.state.settings.site_id == 1 && import.meta.env.MODE === 'production') {
            _tmr.push({
                type: 'reachGoal',
                id: 3290316,
                value: this.card.price_num,
                goal: 'view_product',
                params: {product_id: this.buildVkFeedId()}
            });
            window.dataLayer = window.dataLayer || []
            dataLayer.push({
                "ecommerce": {
                    "currencyCode": "RUB",
                    "detail": {
                        "products": [
                            {
                                "id": this.buildVkFeedId(),
                                "name": this.card.name,
                                "price": this.card.price_num,
                                "brand": "Batnorton",
                                "category": this.card.category_name,
                                "variant": this.card.color?.name,
                                "list": "Просмотр товара",
                                "position": 1
                            }
                        ]
                    }
                }
            });
        }
        if (this.$store.state.settings.site_id === 2 && import.meta.env.MODE === 'production') {
            console.log('Viewed Product')
            klaviyo.track('Viewed Product', {
                ProductID: this.buildVkFeedId(),
                ProductName: this.card.name,
                Category:[this.card.category_name],
                Price: this.card.price_num,
            });
        }
        viewItem(this.card)
    },
    methods: {
        buildVkFeedId() {
            const cardId = this.card?.id
            const categoryId = this.card?.menu_id
            const gender = this.$store.state.settings.gender === 'male' ? 'M' : 'F'

            const id = cardId + '-' + categoryId + '-' + gender

            console.log(id)

            return id
        },
        createViewed(card) {
            this.$parent.$refs.header.updateViewed(card)
        },
        updateSize(size) {
            this.card.offer = this.card.offers.find(item => item.size.id === size.id)
        },
        addFavourites(card) {
            card.favourites = !card.favourites
            this.$parent.$refs.header.updateLike(card)
            if (this.$store.state.settings.site_id === 1 && import.meta.env.MODE === 'production') {
                _tmr.push({
                    type: 'reachGoal',
                    id: 3290316,
                    value: this.card.offer.price_num,
                    goal: 'addToWishlist',
                    params: { product_id: this.buildVkFeedId()}});
            }
        },
        checkLike() {
            if (this.$store.state.settings.basket.favourites.find(it => it.card_id === this.card?.id)) {
                this.card.favourites = true
            }
        },
        addBasketCard(card) {
            this.$parent.$refs.header.createBasket(card)

            if (this.$store.state.settings.site_id === 1 && import.meta.env.MODE === 'production') {
                window.dataLayer = window.dataLayer || []
                dataLayer.push({
                    "ecommerce": {
                        "currencyCode": "RUB",
                        "add": {
                            "products": [
                                {
                                    "id": this.buildVkFeedId(),
                                    "name": card.name,
                                    "price": card.offer.price_num,
                                    "brand": "Batnorton",
                                    "category": card.category_name,
                                    "quantity": 1,

                                }
                            ]
                        }
                    }
                });

                _tmr.push({
                    type: "reachGoal",
                    id: 3290316,
                    value: card.offer.price_num,
                    goal: "add_to_cart",
                    params: {product_id: this.buildVkFeedId()}
                });

                dataLayer.push({
                    event: 'add_to_cart',
                    "ecommerce": {
                        "currencyCode": "RUB",
                        "add": {
                            "products": [
                                {
                                    "id": this.buildVkFeedId(),
                                    "name": card.name,
                                    "price": card.offer.price_num,
                                    "brand": "Batnorton",
                                    "category": card.category_name,
                                    "quantity": 1,
                                }
                            ]
                        }
                    }
                });
            }
            if (this.$store.state.settings.site_id === 2 && import.meta.env.MODE === 'production') {
                console.log('Add to cart')
                klaviyo.track('Add to cart', {
                    ProductID: this.buildVkFeedId(),
                    ProductName: card.name,
                    Category: [card.category_name],
                    Price: card.offer.price_num,
                });
            }
        },

        splitPayment(card) {
            if (card.offer.price_old_num) {
                return card.offer.price_old_num / 4
            } else {
                return card.offer.price_num / 4
            }
        },
        getSizeClass(size) {
            if (!size.purchase) return 'select-size__unavailable'
            if (this.card.sizes[this.offerSizeKey].code === size.code) return 'select-size__active'
        },
        sizeClick(index) {
            if (!this.cards.sizes[index].purchase) {
                this.currentSizeUnavailableId = this.cards.sizes[index].id
                return
            }
            this.offerSizeKey = index
            this.selectList = !this.selectList
            this.updateSize(this.card.sizes[index])
        },
    },
    computed: {
        addToCartDisabled() {
            return  this.card.offer?.purchase ? false : true
        },
  }
}
</script>

<style scoped>

</style>
